<h1 mat-dialog-title class="pt-2 text-center"> Ajout d'un prélevement</h1>
<div mat-dialog-content class="p-0">
    <div class="container no-gutters">

        <div class="row m-0">
            <mat-form-field class="col">
                <mat-label>Type</mat-label>
                <mat-select placeholder="Type" [(ngModel)]="Model.Type">
                    @for (d of PrelevementTypeAdductionList; track d; let i = $index) {
                    <mat-option [value]="i + 1">
                        {{ d }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row m-0 ">
            <mat-form-field class="col">
                <mat-label>Référence Tube</mat-label>
                <input matInput [(ngModel)]="Model.ReferenceTube" placeholder="RéférenceTube" required>
            </mat-form-field>
        </div>

        <div class="row m-0 ">
            <mat-form-field class="col">
                <mat-label>Durée</mat-label>
                <input matInput type="number" [(ngModel)]="Model.Duree" placeholder="Durée" required>
            </mat-form-field>
        </div>

        <div class="row m-0 ">
            <mat-form-field class="col">
                <mat-label>Résultat</mat-label>
                <input matInput  [(ngModel)]="Model.Resultat" placeholder="Résultat" required>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-slide-toggle class="m-1" [(ngModel)]="Model.Conformite">Conformité</mat-slide-toggle>
        </div>

        <div class="row m-1">
            <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
                Annuler
            </button>
            <button appPreventDoubleClick class="col ms-1" mat-raised-button color="primary" (throttledClick)="finish()" [disabled]="!canFinish()">
                Ajouter
            </button>
        </div>
    </div>
</div>